import dayjs from 'dayjs';
import { P2GDate, P2GDatePicker, P2GGrid, P2GLink, P2GText } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import { useEffect, useState } from 'react';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface IRangeSliderProps {
  defaultRefinement: { min: number; max: number };
  currentRefinement: { min: number; max: number };
  canRefine: boolean;
  refine: (values: { min: number; max: number }) => void;
}

const RangeSlider: React.FC<IRangeSliderProps> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [dateRange, setDateRange] = useState<{ start: Date; end: Date }>({
    start: dayjs.unix(props.defaultRefinement.min).toDate(),
    end: dayjs.unix(props.defaultRefinement.max).toDate()
  });
  const [openDatePicker, setOpenDatePicker] = useState<boolean>(false);

  useEffect(() => {
    if (props.canRefine) {
      setDateRange({
        start: dayjs.unix(props.currentRefinement.min).toDate(),
        end: dayjs.unix(props.currentRefinement.max).toDate()
      });
    }
  }, [props.currentRefinement.min, props.currentRefinement.max]);

  const onChange = (range: { min: number; max: number }) => {
    if (props.currentRefinement.min !== range.min || props.currentRefinement.max !== range.max) {
      props.refine(range);
      setDateRange({
        start: dayjs.unix(range.min).toDate(),
        end: dayjs.unix(range.max).toDate()
      });
    }
  };

  return (
    <>
      <P2GGrid container spacing={2} alignContent="center" alignItems="center">
        <P2GGrid item>
          <P2GText>
            <P2GDate date={dateRange.start} /> - <P2GDate date={dateRange.end} />
          </P2GText>
        </P2GGrid>
        {props.canRefine && (
          <P2GGrid item>
            <P2GLink onClick={() => setOpenDatePicker(true)}>
              {t('SEARCH_PAGE_REFINE_RESULTS_EDIT', { defaultValue: 'Edit' })}
            </P2GLink>
          </P2GGrid>
        )}
      </P2GGrid>
      <P2GSidePanel
        open={openDatePicker}
        onClose={() => setOpenDatePicker(false)}
        anchor="right"
        title={t('SEARCH_PAGE_REFINE_RESULTS_DATE_RANGE', { defaultValue: 'Date Range' })}
      >
        <P2GGrid container spacing={2} direction="column">
          <P2GGrid item>
            <P2GDatePicker
              variant="static"
              onChange={(e) => onChange({ min: dayjs(e).unix(), max: dayjs(dateRange.end).unix() })}
              value={dateRange.start}
            >
              {t('SEARCH_PAGE_REFINE_RESULTS_START_DATE', { defaultValue: 'Start Date' })}
            </P2GDatePicker>
          </P2GGrid>
          <P2GGrid item>
            <P2GDatePicker
              variant="static"
              onChange={(e) => onChange({ min: dayjs(dateRange.start).unix(), max: dayjs(e).unix() })}
              value={dateRange.end}
            >
              {t('SEARCH_PAGE_REFINE_RESULTS_END_DATE', { defaultValue: 'End Date' })}
            </P2GDatePicker>
          </P2GGrid>
        </P2GGrid>
      </P2GSidePanel>
    </>
  );
};
export default RangeSlider;
